// extracted by mini-css-extract-plugin
module.exports = {"popper":"tZpV2","fixedPositionPopper":"_1hguP","seperator":"_3zTMh","closeButton":"_2fbYu","files":"_13h9C"};